<nav class="navbar navbar-expand-xl">
    <div class="container-fluid menu-toolbar-mat custom-navbar">
        <a class="navbar-brand" [routerLink]="this._authService.is_user_authenticated() ? '/dashboard' : null" [class.cursor-pointer]="this._authService.is_user_authenticated()">
            <img class="logo" [src]="logo" alt="Agenda Master" />
            <span class="logoText">Agenda Master</span>
        </a>

        <!-- Studios Button Dropdown (Desktop View) with Command Palette -->
        <div class="studio-actions d-none d-xl-flex align-items-center">
            <div class="studio-dropdown">
                <button *ngIf="_authService.is_user_authenticated()" class="menu-item" mat-button
                    [matMenuTriggerFor]="studioMenu">
                    <span class="with-dropdown lighter">{{currentStudio}}
                        <mat-icon aria-hidden="false" aria-label="Studios dropdown"
                            class="menu-dropdown">arrow_drop_down</mat-icon>
                    </span>
                </button>
                <span *ngIf="!_authService.is_user_authenticated()" class="lighter studio-text">{{currentStudio}}</span>
                <mat-menu #studioMenu="matMenu" class="scrollable-menu">
                    <div class="studio-menu-container" (click)="$event.stopPropagation()">
                        <div class="search-container">
                            <mat-form-field appearance="outline">
                                <input #studioSearchInput matInput placeholder="Search studios..."
                                       [(ngModel)]="studioSearchText"
                                       (input)="onStudioSearch()"
                                       (keydown)="$event.stopPropagation()"
                                       (click)="$event.stopPropagation(); studioSearchInput.focus()">
                                <mat-icon matSuffix>search</mat-icon>
                            </mat-form-field>
                        </div>
                        <button class="menu-item" mat-menu-item
                            *ngFor="let studio of filteredStudios; trackBy: trackByStudio"
                            (click)="handleStudioClick(studio); $event.stopPropagation(); studioMenu.closed.emit()">
                            <span class="studio-name">{{studio.key}}</span>
                            <span class="studio-id">{{studio.id}}</span>
                        </button>
                    </div>
                </mat-menu>
            </div>
            <button
                type="button"
                *ngIf="this._authService.is_user_authenticated()"
                (click)="openCommandPalette()"
                aria-label="Open command palette"
                class="menu-item command-palette-button command-palette-desktop">
                <mat-icon>search</mat-icon>
                <span class="search-placeholder-text">Search...</span>
                <span class="search-shortcut">{{ isMac ? '⌘K' : 'Ctrl+K' }}</span>
            </button>
        </div>

        <!-- Add the support button as a new menu item -->
        <!-- <button type="button" class="btn ms-auto me-2 d-lg-none" id="contactSupportButton"><mat-icon>contact_support</mat-icon></button> -->

        <!-- Command Palette Button (Mobile) -->
        <button *ngIf="this._authService.is_user_authenticated()"
            class="menu-item command-palette-button d-xl-none ms-auto me-2"
            type="button"
            (click)="openCommandPalette()"
            aria-label="Open command palette"
            title="Search">
            <mat-icon>search</mat-icon>
        </button>

        <button class="navbar-toggler custom-toggler" type="button"
            (click)="toggleNavbar()" aria-controls="navbarNav"
            aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav"
            [ngClass]="{'show': navbarOpen}">
            <ul class="navbar-nav ms-auto">
                <!-- Studios Button Dropdown (Mobile View) -->
                <li class="nav-item d-xl-none">
                    <button *ngIf="_authService.is_user_authenticated()" class="menu-item" mat-button
                        [matMenuTriggerFor]="studioMenuMobile">
                        <span class="with-dropdown lighter">{{currentStudio}}
                            <mat-icon aria-hidden="false"
                                aria-label="Studios dropdown"
                                class="menu-dropdown">arrow_drop_down</mat-icon>
                        </span>
                    </button>
                    <span *ngIf="!this._authService.is_user_authenticated()" class="lighter studio-text">{{currentStudio}}</span>

                    <mat-menu #studioMenuMobile="matMenu" class="scrollable-menu">
                        <div class="studio-menu-container" (click)="$event.stopPropagation()">
                            <div class="search-container">
                                <mat-form-field appearance="outline">
                                    <input #studioSearchInputMobile matInput placeholder="Search studios..."
                                           [(ngModel)]="studioSearchText"
                                           (input)="onStudioSearch()"
                                           (keydown)="$event.stopPropagation()"
                                           (click)="$event.stopPropagation(); studioSearchInputMobile.focus()">
                                    <mat-icon matSuffix>search</mat-icon>
                                </mat-form-field>
                            </div>
                            <button class="menu-item" mat-menu-item
                                *ngFor="let studio of filteredStudios; trackBy: trackByStudio"
                                (click)="handleStudioClick(studio); $event.stopPropagation(); studioMenuMobile.closed.emit()">
                                <span class="studio-name">{{studio.key}}</span>
                                <span class="studio-id">{{studio.id}}</span>
                            </button>
                        </div>
                    </mat-menu>
                </li>

                <!-- Authenticated User Menu Items -->
                <ng-container *ngIf="this._authService.is_user_authenticated()">
                    <ng-container
                        *ngFor="let item of this._menuRESTService.loadedMenuItems">
                        <!-- Top Level Routes -->
                        <li class="nav-item" *ngIf="!item.below">
                            <button class="menu-item lighter"
                                (click)="closeNavbar()"
                                routerLinkActive="active" mat-button
                                routerLink="{{item.relative}}">
                                <span
                                    class="with-dropdown">{{item.title | appTranslate}}</span>
                            </button>
                        </li>

                        <!-- Nested Routes -->
                        <li class="nav-item"
                            *ngIf="item.below && item.title != 'Administrative' && item.title != 'Tools'">
                            <button class="menu-item" mat-button
                                [matMenuTriggerFor]="menu" appHoverMenuTrigger>
                                <span class="with-dropdown">{{item.title | appTranslate}}
                                    <mat-icon aria-hidden="false"
                                        aria-label="Menu dropdown"
                                        class="menu-dropdown">arrow_drop_down</mat-icon>
                                </span>
                            </button>
                            <mat-menu #menu="matMenu">
                                <ng-container
                                    *ngFor="let nestedItem of item.below">
                                    <button
                                        (click)="closeNavbar()"
                                        *ngIf="nestedItem.title != 'Add Student Account'"
                                        class="menu-item"
                                        routerLinkActive="active"
                                        routerLink="{{nestedItem.relative}}"
                                        mat-menu-item>
                                        <span>{{nestedItem.title | appTranslate}}</span>
                                    </button>
                                    <button
                                        *ngIf="nestedItem.title == 'Add Student Account'"
                                        class="menu-item"
                                        routerLinkActive="active"
                                        (click)="openEntityComponent(StudentInquiryEntityComponent, 'student_accounts', 'student_account', 'create', '', {
                      'dayview_field_date_and_time': '',
                      'inquiry': false
                    })" mat-menu-item>
                                        <span>{{nestedItem.title | appTranslate}}</span>
                                    </button>
                                </ng-container>
                            <button
                                *ngIf="item.title == 'Students' && hasFloatingRainData"
                                class="menu-item"
                                (click)="closeNavbar(); openFloatingRainImportDialog()"
                                mat-menu-item>
                                <span>Import Floating Rain student</span>
                            </button>
                                <!-- Add Payment menu item under Payments menu -->
                                <button
                                    *ngIf="item.title == 'Payments' && _permissionsService.canAccess('payments_collect')"
                                    class="menu-item"
                                    (click)="refreshHelper.openPaymentWithRefresh(PaymentsEntityComponent, 'eck_payment', 'payment', 'create')"
                                    mat-menu-item>
                                    <span>{{'Add Payment' | appTranslate}}</span>
                                </button>
                                <!-- Add Enrollment menu item under Enrollments menu -->
                                <button
                                    *ngIf="item.title == 'Enrollments' && _permissionsService.canAccess('enrollments_create')"
                                    class="menu-item"
                                    (click)="refreshHelper.openEntityWithRefresh(EnrollmentEntityComponent, 'eck_enrollment', 'enrollment', 'create', null, null, 'enrollmentFormWithData')"
                                    mat-menu-item>
                                    <span>{{'Add Enrollment' | appTranslate}}</span>
                                </button>
                                <!-- Gift certificates are sold from their own page under Configuration,
                                     but they create a pre-paid enrollment, so staff look for them here. -->
                                <button
                                    *ngIf="item.title == 'Enrollments' && _permissionsService.canAccess('gift_certificates_create')"
                                    class="menu-item"
                                    (click)="closeNavbar()"
                                    routerLink="/configuration/gift-certificates"
                                    [queryParams]="{ status: 'active' }"
                                    mat-menu-item>
                                    <span>{{'Add Gift Certificate' | appTranslate}}</span>
                                </button>
                                <!-- Add Package menu item under Packages menu -->
                                <button
                                    *ngIf="item.title == 'Packages' && _permissionsService.canAccess('packages_create')"
                                    class="menu-item"
                                    (click)="refreshHelper.openEntityWithRefresh(PackageEntityComponent, 'eck_package', 'package', 'create')"
                                    mat-menu-item>
                                    <span>{{'Add Package' | appTranslate}}</span>
                                </button>
                            </mat-menu>
                        </li>
                    </ng-container>

                    <!-- Add the support button as a new menu item -->
                    <!-- <li class="nav-item">
                        <button class="menu-item" mat-button (click)="openDialog(supportRequestForm, 'statusFormWithData', {})">
                        <mat-icon>contact_support</mat-icon>
                        </button>
                    </li> -->

                    <!-- Admin Menu -->
                    <li class="nav-item">
                        <button class="menu-item" mat-button
                            [matMenuTriggerFor]="menuAdmin" appHoverMenuTrigger>
                            <span class="material-icons">person</span>
                            <span *ngIf="this._authService?.current_user?.name"
                                class="with-dropdown">
                                {{ this._authService.current_user.name }}
                            </span>
                        </button>
                        <mat-menu #menuAdmin="matMenu">
                            <button
                                *ngIf="this._permissionsService.has_access('view_admin_links')"
                                (click)="openAdminLink( '/studio/' + this.currentStudioID + '/edit/')"
                                class="menu-item" routerLinkActive="active"
                                mat-menu-item>
                                <span>Edit Studio Settings</span>
                            </button>
                            <button
                                *ngIf="this._permissionsService.has_access('view_admin_links')"
                                (click)="openAdminLink('/studio-user-register')"
                                class="menu-item" routerLinkActive="active"
                                mat-menu-item>
                                <span>Studio User Register</span>
                            </button>
                            <button
                                *ngIf="this._permissionsService.has_access('view_admin_links')"
                                (click)="openAdminLink('/instructor-reorder')"
                                class="menu-item" routerLinkActive="active"
                                mat-menu-item>
                                <span>Primary Instructor Reorder</span>
                            </button>
                            <button
                                *ngIf="this._permissionsService.has_access('view_admin_links')"
                                (click)="openAdminLink('/admin/reports/audit-trail')"
                                class="menu-item" routerLinkActive="active"
                                mat-menu-item>
                                <span>Audit Trail</span>
                            </button>
                            <button routerLink="configuration" class="menu-item"
                                (click)="closeNavbar()"
                                routerLinkActive="active" mat-menu-item>
                                <span>{{'Configuration' | appTranslate}}</span>
                            </button>
                            <button class="menu-item" routerLinkActive="active"
                                routerLink="auth/logout" mat-menu-item>
                                <span>{{'Logout' | appTranslate}}</span>
                            </button>
                        </mat-menu>
                    </li>
                </ng-container>

                <!-- Login Button (when not authenticated) -->
                <li class="nav-item"
                    *ngIf="!this._authService.is_user_authenticated()">
                    <button routerLink="auth/login" routerLinkActive="active"
                        class="menu-item" mat-button>
                        Log in
                    </button>
                </li>
            </ul>
        </div>
    </div>
</nav>

<!-- Add the refresh helper component at the end of the file -->
<app-refresh-helper #refreshHelper></app-refresh-helper>
